export const columnsList = [
    {
        label: '任务号',
        prop: 'taskNo',
        width: '170'
    },
    {
        label: '客户订单号',
        prop: 'customerOrderNo',
        width: '220'
    },
    {
        prop: 'examineTime',
        label: '时效考核时间',
        width: '180'
    },
    {
        prop: 'appointmentTimes',
        label: '上次预约时间',
        width: '180'
    },
    {
        prop: 'remark',
        label: '客户备注',
        width: '180'
    },
    {
        prop: 'customerName',
        label: '客户',
        width: '220'
    },
    {
        prop: 'expectArrivalTimeStr',
        label: '期望送达时间',
        width: '180'
    },
    {
        prop: 'orderTime',
        label: '接单时间',
        width: '180'
    },
    {
        prop: 'agingProductCode',
        label: '时效产品（十一日达）',
        width: '180'
    }
];
export const rightColumnsListConfig = [
    {
        label: '联系人信息',
        prop: 'contactInfo'
    },
    {
        label: '精准配送',
        prop: 'isJzpFlag',
        width: 80
    },
    {
        label: '时效考核时间',
        prop: 'examineTime',
        width: 160
    },
    {
        label: '运单数',
        prop: 'totalQty',
        width: 80
    },
    {
        label: '方量(m³)',
        prop: 'totalVolume',
        width: 100
    },
    {
        label: '重量(kg)',
        prop: 'totalGrossWeight',
        width: 100
    }
];
export const inventoryDialogColumns = {
    selection: false,
    height: 400,
    columns: [
        { label: '任务号', prop: 'taskNo', width: 180 },
        { label: '客户订单号', prop: 'customerOrderNo', width: 180 },
        { label: '商品名称', prop: 'itemName', width: 180 },
        { label: '商品分类', prop: 'itemClassName', width: 180 },
        { label: '数量', prop: 'planQty', width: 100 },
        { label: '方量(m³)', prop: 'volume', width: 100 },
        { label: '重量(KG)', prop: 'grossWeight', width: 100 },
        { label: '状态', prop: 'itemStatus', width: 80 },
        { label: '商品编码', prop: 'itemCode', width: 120 },
        { label: '客户商品编码', prop: 'customerItemCode', width: 120 }
    ]
};
